import React from 'react';
import PropTypes from 'prop-types';

import { PAGE_PRIVACY, PAGE_LEGAL } from '../../../config/pages';
import Link from '../../helpers/Link';

const FooterBottom = ({ t, openPage, language }) => (
    <div className="footer-bottom" id="footer-bottom">
        <span className="copyright" id="copyright" dangerouslySetInnerHTML={ { __html: t('footer.copyright') } }/>
        <span className="pipe" id="pipe-01"> | </span>
        <Link openPage={ openPage } language={ language } page={ PAGE_PRIVACY } id="footer-link-privacy">{ t('footer.privacy') }</Link>
        <span className="pipe" id="pipe-02"> | </span>
        <Link openPage={ openPage } language={ language } page={ PAGE_LEGAL } id="footer-link-legal">{ t('footer.legal') }</Link>
    </div>
);

FooterBottom.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired
};

export default FooterBottom;



// WEBPACK FOOTER //
// ./src/components/content/common/FooterBottom.jsx